import React, { Component } from "react";
import { monthOptions, yearOptions } from "../../config";
import * as R from "ramda";
import { configDailySalesLeasing } from "../config";
import { mapToObjectDDL, removeNullFields } from "../../../../common/mapper";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleNestedTable from "../../../../../modules/SimpleNestedTable";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";
import moment from "moment";

class DailySalesLeasingReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: null,
      year: null,
      dataSales: [],
      sales: null,
      tableConfig: [],
      dataTable: [],
    };
  }

  componentDidMount = async () => {
    const currentMonth = Number(moment().format("MM"));
    const currentYear = Number(moment().format("YYYY"));
    
    this.setState((prevValue) => ({
      ...prevValue,
      month: monthOptions.find((item) =>
        R.equals(item.value, currentMonth)
      ),
      year: yearOptions.find((item) =>
        R.equals(item.value, currentYear)
      ),
      tableConfig: configDailySalesLeasing,
    }));
    
    if (!R.isNil(this.props.search) && R.equals(this.props.tab, "salesman")) {
      await this.fetchDataSales();
    }
  };

  componentDidUpdate = async (prevProps, prevState, snapshot) => {
    if (!R.equals(prevProps.search, this.props.search)) {
      if (R.equals(this.props.tab, "salesman")) await this.fetchDataSales();
      this.handleSearch();
    }
  };

  formatDate = (days, month, year) =>
    moment(`${days}-${month}-${year}`, "DD-MM-YYYY").format("DD/MM/YYYY");

  constructConfig(value) {
    if (!value?.dataSalesDaily?.length) return [];

    const config = value.dataSalesDaily.map((item) => ({
      key: item.leasingName || item.paymentMethod,
      label: item.leasingName || item.paymentMethod,
      percentSP: item.leasingName ? item.dailyPercentMSCP : item.dailyPercentSP,
      ...item,
    }));

    config.push({
      key: "total",
      label: "Total",
      dailyCash: value.totalDailyCash,
      dailyAccumulation: value.totalDailyAccumulation,
      percentSP: null,
    });

    return config;
  }

  fetchData = async () => {
    this.props.triggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanJualanHarian,
      setError: this.props.setError,
      menuName: "Dashboard Kacab Keatas - Laporan Jual Harin By Cabang",
      args: {
        kodeCabang: [this.props.search],
        year: this.state.year?.value,
        month: this.state.month?.value,
        employeeIdTeamLeader: this.props.idLeader,
        employeeIdSales:
          this.props.tab === "salesman" ? this.state.sales?.value : undefined,
      },
    });
    this.props.triggerLoading();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const daysCount = Object.keys(res.data.data?.totalDailyCash || {}).length;
      this.setState((prevValue) => ({
        ...prevValue,
        tableConfig: this.constructConfig(res.data.data),
        dataTable: Array.from({ length: daysCount }, (_, i) =>
          this.formatDate(i + 1, this.state?.month.value, this.state.year?.value)
        ),
      }));
    }
  };

  fetchDataSales = async () => {
    const { triggerLoading, setError, tab, search, idLeader } = this.props;
    triggerLoading();

    const isSales = tab === "salesman";
    const fn = isSales ? "getSalesDropdownForDashboard" : "getAllMasterSales";

    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA")[fn],
      setError: setError,
      menuName: "Dashboard Level Team Leader - Laporan Harian By Salesman/CS",
      args: isSales
        ? { employeeIdTeamLeader: this.props.idLeader, kodeCabang: search }
        : { paramFilters: { kodeCabang: search } },
    });
    triggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const label = isSales ? "name" : "salesLeadName";
      this.setState((prevValue) => ({
        ...prevValue,
        dataSales: res.data.data?.map((item) =>
          mapToObjectDDL(item[label], item.employeeId)
        ),
      }));
    }
  };

  handleSearchValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleSearch = () => {
    this.fetchData();
  };

  render() {
    const { dataTable, tableConfig, dataSales, sales, month, year } = this.state
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_month"
            box="search"
            name="month"
            isClearable
            containerclassname="width width-250px"
            placeholder="Bulan"
            styles={{
              menu: (provided) => ({
                ...provided,
                position: "relative",
                fontFamily:
                  "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
              }),
            }}
            options={monthOptions}
            value={month}
            onChange={(value, { name }) =>
              this.handleSearchValueChange(name, value)
            }
          />
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            isClearable
            options={yearOptions}
            value={year}
            onChange={(value, { name }) =>
              this.handleSearchValueChange(name, value)
            }
          />
          {R.equals(this.props.tab, "salesman") && (
            <SimpleDDL
              id="select_options_sales"
              box="search"
              name="sales"
              isClearable
              containerclassname="width width-250px"
              placeholder="Select Salesman/CS"
              styles={{
                menu: (provided) => ({
                  ...provided,
                  position: "relative",
                  fontFamily:
                    "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                }),
              }}
              options={dataSales}
              value={sales}
              onChange={(value, { name }) =>
                this.handleSearchValueChange(name, value)
              }
            />
          )}
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <SimpleNestedTable
          data={dataTable}
          config={tableConfig}
        />
      </>
    );
  }
}

export default DailySalesLeasingReport;
